export const data = {
    brand: "Intellipoint Corporation",
};